<div class="row">
  <div class="col-12 d-flex flex-wrap">
    <ng-container *ngFor="let role of userRoles">
      <app-switch-checkbox
        *ngIf="role.type === roleTypes[roleType]"
        bsClass="success"
        bsSize="sm"
        [checked]="userRolesSearch | checkedPipe: role.code"
        (change)="toggleFilter(role.code)"
      >
        {{ role.code }}
      </app-switch-checkbox>
    </ng-container>
  </div>
</div>
